import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Icon, Modal, Spin } from 'antd';
import Moment from "react-moment";
import lodash from 'lodash';
import CapValuationModal from '../Modals/CapValuationModal';
import Table from "../../../../../components/table/Table";

const style = { width: '25%' };
const titles = ['Date', 'Retail', 'Clean', 'Avg.'];

export default connect((state) => {
    const { cap_valuation, loading, cap_valuation_history } = state.Leads.Lead_profile.Lead_cap_valuation;
    const { _id } = state.Leads.Lead_profile.Lead_general.current_status;
    return {
        cap_valuation, loading, _id, cap_valuation_history
    };
}, null)(class CapValuation extends PureComponent {
  state = {
      visible: false,
  };

  openCAPValuationModal = () => this.setState({ visible: true });

  closeModal = () => this.setState({ visible: false });

  showValuationValue = (value) => (value > 1 ? `£${value}` : '-');

  render() {
      const { cap_valuation, _id, cap_valuation_history } = this.props;
      let capValuationHistory = [cap_valuation];

      if (cap_valuation_history && !lodash.isEmpty(cap_valuation_history)) {
          capValuationHistory = cap_valuation_history.sort((a,b) => new Date(b.date) - new Date(a.date));
      }


      return (
          <Spin spinning={this.props.loading} tip="CAP Valuation checking ...">
              <div className="profile__information cap">
                  {cap_valuation
          && (
              <div className="profile__data valuation">
                  <h3>
                      CAP Valuation
                      <span className="select_manually" onClick={this.openCAPValuationModal}>
                          <Icon type="edit" style={{ paddingRight: '5px' }} />
                          Select Manually
                      </span>
                  </h3>
                  <div className="tableWrapper">
                      <div className="profile__contact">
                          <Table>
                              <thead>
                              <tr>{titles.map((title, index) => <th key={index} className="tableHeader">{title}</th>)}</tr>
                              </thead>
                              <tbody>
                              {capValuationHistory.map(({date, retail, clean, avg, _id}) => {
                                  return (
                                      <tr key={_id}>
                                          <td style={ style }>{date ? <Moment format="D MMM YYYY">{date}</Moment> : '-'}</td>
                                          <td style={ style }>{this.showValuationValue(retail)}</td>
                                          <td style={ style }>{this.showValuationValue(clean)}</td>
                                          <td style={ style }>{this.showValuationValue(avg)}</td>
                                      </tr>
                                  )
                              })}
                              </tbody>
                          </Table>

                      </div>
                  </div>
              </div>
          )}
                  <Modal width={1100} visible={this.state.visible} onCancel={this.closeModal} footer={null}>
                      <CapValuationModal closeModal={this.closeModal} />
                  </Modal>
              </div>
          </Spin>
      );
  }
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Lead_profile_table/CapValuation.js